import * as http from '~/utils/apis';
export const API_PREFIX = 'cms-api/card-saga/character-classes';
import { ResponseTransformer } from '../ResponseTransformer';
import { titleCase } from '~/utils/helpers';

export const characterClassCardApi = {
    getAll: async () => {
        const { data } = await http.get(`${API_PREFIX}`);
        return data;
    },

    create: async () => {
        const { data } = await http.get(`${API_PREFIX}/create`);

        const card = new ResponseTransformer(data);
        card.transformObjectKey();

        return card;
    },

    store: async (body) => {
        const { data } = await http.post(`${API_PREFIX}`, body, {});

        return data;
    },

    show: async (name) => {
        const { data } = await http.get(`${API_PREFIX}/${name}`);
        const card = new ResponseTransformer(data);
        card.transformObjectKey();
        card.transformRarities();
        card.transformSkinSizes();

        return card;
    },

    update: async (id, body) => {
        await http.put(`${API_PREFIX}/${id}`, body, {});
    },

    delete: async (id) => {
        await http.destroy(`${API_PREFIX}/${id}`);
    },
};

function transformRarities() {
    const result = Object.entries(this.data.rarities).map(([id, name]) => ({ id, name }));
    this.data.rarities = result;
}
function transformSkinSizes() {
    this.data.skinSizes.forEach(function (item, i, arr) {
        arr[i] = {
            id: item,
            name: titleCase(item),
        };
    });
}
ResponseTransformer.prototype.transformRarities = transformRarities;
ResponseTransformer.prototype.transformSkinSizes = transformSkinSizes;
